export const ActionTypes = {
    IS_LOGGED_IN: 'IS_LOGGED_IN',
    AUTH: 'AUTH',
    ERROR: 'ERROR',
    REQUEST: 'REQUEST',
    SUCCESS: 'SUCCESS',
    GLOBAL_RESET: 'GLOBAL_RESET',
    ACCESS_TOKEN: 'ACCESS_TOKEN',
    USER_DATA: 'USER_DATA',
  
  };
  